import { resolveClassNames } from "./auth-service-tools192.js";

function getResolvedClassNames(_ref) {
  let {
    selector,
    stylesCtx,
    theme,
    classNames,
    props
  } = _ref;
  return resolveClassNames({
    theme,
    classNames,
    props,
    stylesCtx
  })[selector];
}

export { getResolvedClassNames };